import moment from 'moment';

export const isPlural = (numb: number) => {
  return numb > 1 ? 's' : '';
};

export const dateToDuration = (
  date: Date | number | string,
  isV2 = false
): string => {
  let mDate = moment(date);
  if (typeof date === 'number') {
    mDate = moment(date);
  } else if (typeof date === 'string') {
    mDate = moment(date, 'YYYY-MM-DD HH:mm:ss');
  }
  const dateToday = moment(new Date());
  const durationDate = moment.duration(dateToday.diff(mDate));
  const years = durationDate.years();
  const months = durationDate.months();
  const weeks = durationDate.weeks();
  const days = durationDate.days();
  const hours = durationDate.hours();
  const minutes = durationDate.minutes();
  const seconds = durationDate.seconds();

  if (isV2) {
    return years
      ? `${years} year${isPlural(years)} ago`
      : months
      ? `${months} month${isPlural(months)} ago`
      : weeks
      ? `${weeks} week${isPlural(weeks)} ago`
      : days
      ? `${days} day${isPlural(days)} ago`
      : `today`;
  }
  return months
    ? `${months} month${isPlural(months)} ago`
    : weeks
    ? `${weeks} week${isPlural(weeks)} ago`
    : days
    ? `${days} day${isPlural(days)} ago`
    : hours
    ? `${hours} hour${isPlural(hours)} ago`
    : minutes
    ? `${minutes} minute${isPlural(minutes)} ago`
    : `${seconds} second${isPlural(minutes)} ago`;
};
